import React from 'react';

const AppTokenContext = React.createContext();

const AppTokenProvider = AppTokenContext.Provider;
const AppTokenConsumer = AppTokenContext.Consumer;

export { AppTokenProvider, AppTokenConsumer }